module.exports = __webpack_public_path__ + "static/media/img2.8968cdb3.png";